import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';

// useLayoutEffect warns during a server render; nothing is measured there anyway.
const useBrowserLayoutEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;

// Grows and shrinks smoothly as its content changes height, e.g. a popup
// whose placeholders give way to however many rows load. Without
// ResizeObserver it leaves the height to the content.
export default function AnimatedHeight({ className = '', children }) {
	const contentRef = useRef(null);
	const [height, setHeight] = useState(null);

	useBrowserLayoutEffect(() => {
		if(typeof ResizeObserver === 'undefined' || !contentRef.current) {
			return undefined;
		}
		const measure = () => setHeight(contentRef.current.offsetHeight);
		measure();
		const observer = new ResizeObserver(measure);
		observer.observe(contentRef.current);
		return () => observer.disconnect();
	}, []);

	return (
		<div className={`animated-height ${className}`.trim()} style={height === null ? undefined : { height }}>
			<div className='animated-height__content' ref={contentRef}>{children}</div>
		</div>
	);
}
